var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8313_148248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33999 6.41172L0.859985 12.9017L7.34999 19.3817L13.84 12.9017L7.33999 6.41172ZM3.68999 12.9017L7.34999 9.24172L11 12.9017L7.33999 16.5617L3.68999 12.9017ZM19.36 6.64172C17.61 4.88172 15.3 4.00172 13 4.00172V0.761719L8.75999 5.00172L13 9.24172V6.00172C14.79 6.00172 16.58 6.68172 17.95 8.05172C20.68 10.7817 20.68 15.2217 17.95 17.9517C16.58 19.3217 14.79 20.0017 13 20.0017C12.03 20.0017 11.06 19.7917 10.16 19.3917L8.66999 20.8817C10.02 21.6217 11.51 22.0017 13 22.0017C15.3 22.0017 17.61 21.1217 19.36 19.3617C22.88 15.8517 22.88 10.1517 19.36 6.64172Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8313_148248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.e7f099b9de31afa7928bbd5d4490af06.svg";
export { ForwardRef as ReactComponent };